const ROUTES = {
  HOME: '/dashboard',
  LOGIN: '/login',
  TEMPLATE_LIST: '/templates',
  TEMPLATE_CREATE: '/templates/create',
  TEMPLATE_EDIT: '/templates/edit',
  TEMPLATE_VIEW: '/templates/view',
  WORKFLOW_LIST: '/workflows',
  WORKFLOW_CREATE: '/workflows/create',
  WORKFLOW_EDIT: '/workflows/edit',
  WORKFLOW_VIEW:'/workflows/view',
  INVENTORY_LIST: '/inventory',
  INVENTORY_CREATE: '/inventory/create',
  INVENTORY_EDIT: '/inventory/edit',
  DOCUMENTATION_LIST: '/documentation',
  DOCUMENTATION_VIEW: '/documentation/view',
  DATA_MODEL_LIST: '/data-models',
  DATA_MODEL_CREATE: '/data-models/create',
  DATA_MODEL_EDIT: '/data-models/edit',
  DATA_MODEL_VIEW: '/data-models/view',
  CREDENTIAL_LIST: '/credentials',
  CREDENTIAL_EDIT: '/credentials/edit',
  CREDENTIAL_VIEW: '/credentials/view',
  CREDENTIAL_CREATE: '/credentials/create',
  PROJECT_LIST: '/projects',
  PROJECT_EDIT: '/projects/edit',
  PROJECT_CREATE: '/projects/create',
  USER_LIST: '/users',
  USER_CREATE: '/user/create',
  USER_EDIT: '/user/edit',
  COMPANY_LIST: '/companies',
  COMPANY_EDIT: '/companies/edit',
  COMPANY_CREATE: '/companies/create',
  CONFIGURATION: '/configurations',
  JOB_LIST: '/jobs',
  JOB_RUN_WORKFLOW: '/jobs/run/workflow',
  JOB_RUN_TEMPLATE: '/jobs/run/template',
  CHANGE_PASSWORD: '/changePassword',
  ROLE_LIST: '/roles',
  ROLE_CREATE: '/role/create',
  ROLE_EDIT: '/role/edit',
  MACRO_EXECUTE: '/macro',
  API_TOKEN_LIST: '/api-tokens',
  NIKO_CHAT: '/niko'
};

export { ROUTES };
